// corporate/html/js/corp-2021/src/home.js
import './_site-wide'
// import './shopraise-tracking-pixel'


// Currency Formatter
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

// Find all slider groups on the page
const sliderGroups = document.querySelectorAll('.slider-group');

sliderGroups.forEach(group => {
  const input = group.querySelector('.slider-input');
  const bubble = group.querySelector('.slider-bubble');
  const progress = group.querySelector('.slider-progress-visual');
  const formatType = group.dataset.format; // 'currency' or 'percent'

  function updateSlider() {
    const val = parseFloat(input.value);
    const min = parseFloat(input.min);
    const max = parseFloat(input.max);

    // 1. Calculate percentage for CSS movement
    const percent = ((val - min) / (max - min)) * 100;

    // 2. Update visual progress bar and bubble position
    progress.style.width = `${percent}%`;
    bubble.style.left = `${percent}%`;

    // 3. Update bubble text based on the data-format attribute
    if (formatType === 'currency') {
      bubble.textContent = currencyFormatter.format(val);
    } else if (formatType === 'percent') {
      bubble.textContent = `${val}%`;
    }
  }

  // Listen for user interaction
  input.addEventListener('input', updateSlider);

  // Initialize position on page load
  updateSlider();
});



// Format currency helper
/*
const formatCurrency = (num) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(num);
};
*/


/*
  Input elements
*/

const numEmployeesElem  = document.getElementById('employee-count');
const averageSalaryElem = document.getElementById('average-salary');
const turnoverRateElem  = document.getElementById('turnover-rate');
const costToReplaceElem = document.getElementById('cost-to-replace');

const inputCollection = [numEmployeesElem, averageSalaryElem, turnoverRateElem, costToReplaceElem];

/*
  Result elements
*/
const resBigTotalElem   = document.getElementById('res-big-total');
const summaryTurnoverElem = document.getElementById('summary-turnover');
const summaryProductivityElem = document.getElementById('summary-productivity');
const summaryAbsenteeismElem = document.getElementById('summary-absenteeism');
const summaryTotalROIElem = document.getElementById('summary-total-roi');
const summaryInvestmentElem = document.getElementById('investment-amount');

/*
  Details section elements
*/
// Employees Retained section
const employeesRetainedElem = document.getElementById('employees-retained');
const expectedTurnoverElem = document.getElementById('expected-turnover');
const replacementCostElem = document.getElementById('replacement-cost');
const turnoverReductionElem = document.getElementById('turnover-reduction');
const totalSavingsElems = document.querySelectorAll('.total-savings');
// Productivity section
const totalBoostElems = document.querySelectorAll('.total-boost');
const employeeCountElems = document.querySelectorAll('.employee-count');
const revenueGeneratedElem = document.getElementById('revenue-generated');
const minimumBoostElem = document.getElementById('minimum-boost');
// Absenteeism section
const totalAbsenteeismSavingsElems = document.querySelectorAll('.total-absenteeism-savings');
// employee-count handled above with employeeCountElems
const absenteeismCostElem = document.getElementById('absenteeism-cost');
const reductionInAbsenteeismElem = document.getElementById('reduction-in-absenteeism');

const grandTotalSavingsElem = document.getElementById('grand-total-savings');


function calculate() {
  // Get values from inputs
  const numEmployees = parseFloat(numEmployeesElem.value) || 0; // integer
  const averageSalary = parseFloat(averageSalaryElem.value) || 0; // integer whole dollars
  const turnoverRate = (parseFloat(turnoverRateElem.value) || 0) / 100; // percent
  const costToReplace = (parseFloat(costToReplaceElem.value) || 0) / 100; // percent

  // Constants from requirements
  const reductionInTurnover = 0.10; // 10%
  const revenueGeneratedPerEmp = 120000;
  const minimumBoost = 0.01; // 1%
  const absenteeismCostPerEmp = 3540; // Note: Using provided $3840 from your text
  const reductionInAbsenteeism = 0.10; // 10%
  const investmentAmount = numEmployees * 24; // Number of employees * $2 * 12

  // 1. Return from employees retained
  // Employees Retained = numEmployees * 10% rounded up
  const employeesRetained = Math.ceil(numEmployees * turnoverRate * 0.10);

  // 2. Calculation for Turnover Savings
  // expectedTurnover = numEmployees * turnoverRate
  // $costToReplace = averageSalary * expectedTurnover * %costToReplace * reductionInTurnover
  const expectedTurnover = numEmployees * turnoverRate;
  const turnoverSavings = averageSalary * expectedTurnover * costToReplace * reductionInTurnover;
  const replacementCost = averageSalary * costToReplace;
  // reductionInTurnover % is const set above
  const totalSavings = employeesRetained * replacementCost;

  // 3. Return from Employees boosted productivity
  // Total = numEmployees * revenueGenerated * minimumBoost
  const productivitySavings = numEmployees * revenueGeneratedPerEmp * minimumBoost;

  // 4. Reduce Absenteeism
  // Total = numEmployees * absenteeismCost * reductionInAbsenteesim
  const absenteeismSavings = numEmployees * absenteeismCostPerEmp * reductionInAbsenteeism;

  // Sum Total
  const totalROI = turnoverSavings + productivitySavings + absenteeismSavings;

  // Update UI - Breakdown Section
  summaryTurnoverElem.innerText = currencyFormatter.format(turnoverSavings);
  summaryProductivityElem.innerText = currencyFormatter.format(productivitySavings);
  summaryAbsenteeismElem.innerText = currencyFormatter.format(absenteeismSavings);
  summaryInvestmentElem.innerText = currencyFormatter.format(investmentAmount);
  [
    resBigTotalElem, 
    summaryTotalROIElem,
    grandTotalSavingsElem,
  ].forEach(el => el.innerText = currencyFormatter.format(totalROI));

  /* Employees Retained section
      - employeesRetainedElem
      - expectedTurnoverElem
      - replacementCostElem
      - turnoverReductionElem
      - totalSavingsElem
  */
  employeesRetainedElem.innerText = employeesRetained;
  expectedTurnoverElem.innerText = parseFloat(expectedTurnover.toFixed(1));
  replacementCostElem.innerText = currencyFormatter.format(replacementCost);
  turnoverReductionElem.innerText = `${(reductionInTurnover * 100).toFixed(0)}%`; // turnoverReduction.toFixed(1);
  totalSavingsElems.forEach(el => el.innerText = currencyFormatter.format(totalSavings));

  /* Productivity Boost section
      - totalBoostElems
      - employeeCountElems
      - revenueGeneratedElem
      - minimumBoostElem
  */
  totalBoostElems.forEach(el => el.innerText = currencyFormatter.format(productivitySavings));
  employeeCountElems.forEach(el => el.innerText = numEmployees);
  revenueGeneratedElem.innerText = currencyFormatter.format(revenueGeneratedPerEmp);
  minimumBoostElem.innerText = `${(minimumBoost * 100).toFixed(0)}%`;
  /* Absenteeism Reduction section
      - totalAbsenteeismSavingsElems
      - employeeCountAbsenteeismElems
      - absenteeismCostElem
      - reductionInAbsenteeismElem
  */
  totalAbsenteeismSavingsElems.forEach(el => el.innerText = currencyFormatter.format(absenteeismSavings));
  absenteeismCostElem.innerText = currencyFormatter.format(absenteeismCostPerEmp);
  reductionInAbsenteeismElem.innerText = `${(reductionInAbsenteeism * 100).toFixed(0)}%`;
}

// Add event listeners to all inputs
inputCollection.forEach(el => {
  el.addEventListener('input', calculate);
});

// Initialize calculation on load
calculate();
